export default "__VITE_ASSET__4d448661__"